import React from 'react';
import { Helmet } from 'react-helmet-async';

const NotFoundPage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <Helmet>
        <title>404 - Page Not Found | Fat Scientist</title>
        <meta name="description" content="The page you are looking for could not be found." />
      </Helmet>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist or has been moved.</p>
      <p>
        <a href="/">Go to Homepage</a>
      </p>
    </div>
  );
};

export default NotFoundPage;
